import { useState, useEffect } from 'react';

export const usePhoneNumber = () => {
    const [phoneNumber, setPhoneNumber] = useState('+34 614 21 19 19');
    const [whatsAppNumber, setWhatsAppNumber] = useState('34614211919');

    useEffect(() => {
        const checkTime = () => {
            const now = new Date();
            // Get hour in Spain/Barcelona time
            const spainTime = new Date(now.toLocaleString("en-US", { timeZone: "Europe/Madrid" }));
            const hour = spainTime.getHours();

            // Shift 1: 00:00 (12 AM) to 08:00 (8 AM) -> +34 612 56 27 55
            // Shift 2: 08:00 (8 AM) to 14:00 (2 PM) -> +34 624 04 25 77
            // Shift 3: 14:00 (2 PM) to 00:00 (12 AM) -> +34 614 21 19 19

            if (hour >= 0 && hour < 8) {
                // Night/Early Morning (12 AM - 8 AM)
                setPhoneNumber('+34 612 56 27 55');
                setWhatsAppNumber('34612562755');
            } else if (hour >= 8 && hour < 14) {
                // Morning (8 AM - 2 PM)
                setPhoneNumber('+34 624 04 25 77');
                setWhatsAppNumber('34624042577');
            } else {
                // Afternoon/Evening (2 PM - 12 AM)
                setPhoneNumber('+34 614 21 19 19');
                setWhatsAppNumber('34614211919');
            }
        };

        checkTime(); // Initial check
        const interval = setInterval(checkTime, 60000); // Check every minute

        return () => clearInterval(interval);
    }, []);

    return { phoneNumber, whatsAppNumber };
};
